import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'al2007',
    ecrans: ['00-2'],
    params: ['id', 'dlpcleint']
});
